/* This array of CustomerResponse Template ID's is use to decide whether it is used to PTP or Paid Response Template*/
export const paymentArrayJson = {
  paidArray: [50, 991, 992, 993, 994, 995, 996, 116, 124, 120],
  ptpArray: [46, 1013, 1014, 1015, 1016, 1017, 1018, 108],
  followUpDate: [
    102,
    111,
    112,
    90,
    91,
    93,
    188,
    196,
    103,
    104,
    999,
    1000,
    1001,
    1002,
    1003,
    1004,
    1005,
    1034,
    1035,
    2743,
    2744
  ],
  offerArray: [362, 1036, 2818],
  drpRequestArray: [2709],
  CustomerResponseTemplateToOfferType: {
    362: 4, // of type waiver
    1036: 1, // of type offer
    2818: 5 // of type Cashback offer
  }
};
